<template>
    <div class="row">
        <h3>Scenes</h3>
        <SceneItem
            v-for="scene in Object.values(scenes)"
            v-bind:key="scene._id"
            v-bind:scene="scene"
            @onEdit="onEdit"
            @onSelect="onSelect"
            @onMoveAll="onMoveAll"
        />
    </div>
</template>

<script lang="ts">
import SceneItem from './SceneItem.vue';

export default {
    name: 'SceneList',
    display: 'Scenes',
    components: {
        SceneItem: SceneItem,
    },
    props: {
        scenes: {
            type: Object,
            default: function() {
                return {};
            },
        },
    },
    data: function() {
        return {
            selected: null,
        };
    },
    methods: {
        onEdit: function({ scene }) {
            this.$emit('onEdit', { scene });
        },
        onSelect: function({ scene, component }) {
            if (this.selected) {
                this.selected.selected = false;
            }
            this.selected = component;
            this.selected.selected = true;
            this.$emit('onSelected', { scene });
        },
        onMoveAll: function({ scene }) {
            this.$emit('onMoveAll', { scene });
        },
    },
};
</script>
